<template>
    <div>
        <v-alert :value="(selectedSite && result ? !result.Edit : false)" prominent type="warning"
                 transition="scroll-y-transition">
            <div class="d-flex align-center">
                <div>
                    Aktuell zur Bearbeitung durch <b>{{ result && !result.Edit ? Utils.getName(result.Mail) : '' }}</b>
                    gesperrt.
                </div>
                <div style="width: min-content" class="ml-4" v-if="result && result.GetEdit">
                    <TooltipButton :right="true" color="#c46d00" @click="showOverrideDialog = true"
                                   :css="{fontSize:'0.775rem', height: '30px', padding: '0 10px'}"
                                   tooltip="Rechte anfordern, um die Seite zu bearbeiten">jetzt übertragen
                    </TooltipButton>
                </div>
            </div>
        </v-alert>
        <Dialog v-model="showOverrideDialog" title="Rechte übertragen"
                ok-text="Übertragen" @ok="override"
                @cancel="showOverrideDialog = false">
            <p>Bist du dir sicher, dass du die Rechte übertragen möchtest?</p>
            <p>Die Seite <b>{{ selectedSite ? selectedSite.Name : null }}</b> wird dann für
                <b>{{ result ? Utils.getName(result.Mail) : null }}</b> blockiert und für dich freigegeben.</p>
            <p>Bitte bemerke, dass dieser Prozess bis zu 15 min dauern kann.</p>
        </Dialog>
    </div>
</template>

<script>
import Utils from "../../scripts/Utils";
import TooltipButton from "../../components/buttons/TooltipButton";
import Dialog from "../../components/Dialog";

export default {
    name: "SiteStatus",
    components: {Dialog, TooltipButton},
    props: ['currentIntervalId', 'store', 'type', 'startIntervalEvent'],
    data: () => {
        return {
            intervalId: null,
            showOverrideDialog: false,
            result: null,
            Utils
        }
    },
    mounted() {
        if (!this.userIsReadOnly) {
            this.fetchSiteStatus();
            this.$root.$on('active', this.startInterval);
        }
    },
    destroyed() {
        if (!this.userIsReadOnly) this.$root.$off('active', this.startInterval);
    },
    computed: {
        vuexState() {
            return this.$store.state[this.store];
        },
        selectedSite() {
            return this.vuexState.selectedSite;
        },
        readOnly() {
            return this.$store.state.readOnly;
        },
        userIsReadOnly() {
            return this.$store.state.users.role === "read";
        }
    },
    methods: {
        async fetchSiteStatus() {
            if (this.selectedSite && !this.userIsReadOnly && ['display', 'video', 'jsoneditor'].includes(this.$route.name)) {
                await this.$store.dispatch('display/siteStatus', {
                    siteId: this.selectedSite.SiteId,
                    type: this.type || this.store,
                }).then((res) => {
                    this.result = res;
                });
            }
        },
        async override() {
            if (!this.userIsReadOnly) {
                await this.$store.dispatch('display/siteStatus', {
                    siteId: this.selectedSite.SiteId,
                    type: this.type || this.store,
                    override: true
                }).then((res) => {
                    if (res && res.Status) {
                        this.$root.$emit('snackbar', 'Rechte erfolgreich angefragt.')
                        this.showOverrideDialog = false;
                    }
                    this.fetchSiteStatus();
                });
            }
        },
        startInterval() {
            if (!this.userIsReadOnly) {
                this.fetchSiteStatus();
                this.intervalId = setInterval(() => {
                    this.fetchSiteStatus();
                }, 5000)
                this.$emit('intervalStart', this.intervalId);
            }
        }
    },
    watch: {
        selectedSite(n, o) {
            if (!this.userIsReadOnly && ((n && o && n.SiteId !== o.SiteId) || (o === null && n !== null))) {
                this.fetchSiteStatus();
                this.startInterval();
            }
        },
        startIntervalEvent() {
            if (!this.userIsReadOnly && this.selectedSite) {
                this.fetchSiteStatus();
                this.startInterval();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-alert--prominent .v-alert__icon {
    align-self: center;
    height: 30px;
    min-width: 30px;
}

::v-deep .v-alert {
    padding: 10px 16px;
}
</style>